module.exports = __webpack_public_path__ + "img/d.cefe83e4.png";